export const InstructionStyles = {
    container:
        'bg-iw-paleGray rounded-xl flex flex-col items-start justify-center gap-2 p-4 pr-10 overflow-y-auto sm:max-h-[38vh] max-h-[37vh]',
    instructionContent: 'flex flex-col items-left gap-2 sm:gap-3 rounded-lg px-8 py-2',
    questionContainer: "flex gap-2 items-center align w-full",
    instructionQuestion:
        'text-xs sm:text-sm md:text-md text-left font-montserrat font-semibold text-black',
    instructionText:
        'text-xs sm:text-sm md:text-md text-left font-montserrat font-normal text-black list-disc pl-2 ',
    instructionTextStrong:
        'text-xs sm:text-sm md:text-md text-left font-montserrat text-black'
}